<template>
  <div class="sticker-page-container" dir="rtl">
    
    <!-- 1. لوحة التحكم (تظهر فقط على الشاشة) -->
    <div class="card shadow-sm mb-5 no-print control-panel">
      <div class="card-header bg-dark text-white">
        <h5 class="mb-0"><i class="fas fa-print ms-2"></i> طباعة ملصقات مظاريف الأسئلة/الإجابة</h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="form-label fw-bold">المادة</label>
            <input v-model="subject" type="text" class="form-control" placeholder="مثال: اللغة العربية">
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold">عدد المجموعات (Loop)</label>
            <input v-model.number="groupCount" type="number" class="form-control" placeholder="عدد المجموعات">
          </div>
          <div class="col-md-4">
            <button @click="printStickers" class="btn btn-primary w-100 fw-bold">
              <i class="fas fa-print ms-2"></i> معاينة وطباعة
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة (الملصقات) -->
    <div id="printSection" class="print-area" >
      
      <!-- حلقة تكرار المجموعات -->
      <div v-for="gIndex in groupCount" :key="gIndex" class="group-page" >
        
        <!-- حلقة تكرار المظاريف داخل المجموعة (أ، ب، ج، د) -->
        <div class="stickers-grid">
            <div v-for="(item, vIndex) in value" :key="vIndex" class="sticker-card">
            
            <!-- رأس الملصق -->
            <div class="sticker-header">
                <div class="row align-items-center">
                    <div class="col-4 text-start">
                        <span class="badge bg-dark text-white fs-3">مجموعة رقم: {{ gIndex }}</span>
                    </div>
                    <div class="col-4 text-center">
                        <h1 class="m-0 fw-bold text-decoration-underline">{{ subject }}</h1>
                    </div>
                    <div class="col-4 text-center">
                         <span class="small fw-bold border p-1">الشهادة الإعدادية</span>
                    </div>
                </div>
            </div>

            <!-- جسم الملصق (البيانات) -->
            <div class="sticker-body">
                <div class="data-grid">
                    
                    <!-- رقم المظروف -->
                    <div class="data-item envelope-num">
                        <span class="label">رقم المظروف</span>
                        <div class="value-box dashed">{{ item.number }}</div>
                    </div>

                    <!-- من - إلى -->
                    <div class="data-item range-from">
                        <span class="label">من رقم سري</span>
                        <div class="value-box dashed">{{ item.from }}</div>
                    </div>

                    <div class="data-item range-to">
                        <span class="label">إلى رقم سري</span>
                        <div class="value-box dashed">{{ item.to }}</div>
                    </div>

                     <!-- العدد -->
                     <div class="data-item count">
                        <span class="label">العدد</span>
                        <div class="value-box dashed">{{ (item.to - item.from) + 1 }}</div>
                    </div>

                </div>

                <!-- تذييل الملصق (ما عدا) -->
                <div class="sticker-footer mt-2">
                    <div class="d-flex align-items-center">
                        <span class="fw-bold ms-2">ما عدا الأرقام:</span>
                        <div class="flex-grow-1 border-bottom border-dark border-2 dotted-line"></div>
                  
                    </div>
                    <div class="d-flex align-items-center" style="
    padding-top: 26px;
    padding-bottom: 28px;
">
                       
                        <div class="flex-grow-1 border-bottom border-dark border-2 dotted-line"></div>
                  
                    </div>
                </div>
            </div>

            </div>
        </div>

        <!-- فاصل صفحات بعد كل مجموعة كاملة (أو يمكن إزالته لطباعة متصلة) -->
        <!-- <div class="page-break"></div> -->

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "EnvelopeStickers",
  data() {
    return {
      groupCount: 1, // تم تغيير الاسم ليكون أوضح (عدد المجموعات)
      subject: "اللغة العربية", // قيمة افتراضية للتجربة
      value: [
        { number: "1 - أ", from: 1, to: 50 },
        { number: "2 - ب", from: 51, to: 100 },
        { number: "3 - ج", from: 101, to: 150 },
        { number: "4 - د", from: 151, to: 200 },
      ],
    };
  },
  methods: {
    printStickers() {
          const options = {
  name: '_balnk',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
 
    '/css/adminlte.rtl.css',
    '/assets/css/rtl.css',
    '/assets/css/sticker.css',
    'https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap',
   

  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: false, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}
       this.$htmlToPaper("printSection", options, () => {
    console.log("Printing Done");
  });

     
    },
  },
};
</script>

<style scoped>
/* 1. تنسيقات الشاشة العادية */
.control-panel {
    max-width: 800px;
    margin: 0 auto;
}

/* 2. تصميم الملصق (Sticker Design) */
.sticker-card {
    border: 3px solid #000;
    padding: 15px;
    margin-bottom: 20px;
    background: white;
    border-radius: 0; /* حواف حادة للقص */
    page-break-inside: avoid; /* يمنع قص الملصق نصفين عند الطباعة */
}

.sticker-header {
    border-bottom: 2px solid #000;
    padding-bottom: 10px;
    margin-bottom: 15px;
}

/* شبكة البيانات داخل الملصق */
.data-grid {
    display: grid;
    grid-template-columns: 1.5fr 1fr 1fr 0.5fr; /* تقسيم الأعمدة */
    gap: 10px;
    align-items: end;
}

.label {
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 5px;
    background-color: #eee;
    border: 1px solid #000;
}

.value-box {
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    font-weight: bold;
    font-family: 'Courier New', Courier, monospace;
}

.value-box.dashed {
    border: 3px dashed #000;
}

.dotted-line {
    border-bottom-style: dotted !important;
}

/* 3. تنسيقات الطباعة (Media Print) */
@media print {
    @page {
        size: A4 portrait;
        margin: 10mm;
    }

    body * {
        visibility: hidden;
    }

    /* إخفاء كل شيء ما عدا منطقة الطباعة */
    .no-print {
        display: none !important;
    }

    #printSection, #printSection * {
        visibility: visible;
    }

    #printSection {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }

    /* تحسين العرض في الطباعة */
    .sticker-card {
        border: 4px solid #000; /* حدود أسمك في الطباعة */
        margin-bottom: 30px; /* مسافة للقص */
    }

    .label {
        background-color: #e0e0e0 !important; /* لون رمادي للطباعة */
        -webkit-print-color-adjust: exact;
    }
    
    .badge {
        color: black !important;
        border: 1px solid black;
        background: transparent !important;
    }

    .page-break {
        page-break-after: always;
    }
}
</style>